import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractFeatureEntityStore } from '@y42/feature';
import { DataLineageGitFactoryService } from './data-lineage-git-factory.service';
import { DataLineageState } from './data-lineage.model';

const initialState: DataLineageState = {
  loading: true,
  last_used: {},
  starred: {},
  active: null,
  ui: {},
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'data-lineage', idKey: '$path' })
export class DataLineageStore extends AbstractFeatureEntityStore<DataLineageState> {
  constructor(protected readonly gitFactory: DataLineageGitFactoryService) {
    super({
      name: 'DataLineage',
      gitFactory,
      initialState,
    });
  }
}
